"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownRegionError = exports.UnknownStageError = exports.UnknownRbiMethodError = exports.UnknownRbiMessageQueueError = exports.UnknownBrandError = exports.PosVendorMismatchError = exports.MissingRequiredParametersError = exports.EnumMemberNotFoundError = exports.CastError = exports.BrandNotSupportedError = exports.RbiError = void 0;
const http_status_codes_1 = __importDefault(require("http-status-codes"));
// all error will inherit from RbiError, which inherits from base Error
class RbiError extends Error {
    constructor(message) {
        super(message);
        // by default, all errors will have a 500 code
        // in each error, this can be overridden as shown below
        this.statusCode = http_status_codes_1.default.INTERNAL_SERVER_ERROR;
    }
}
exports.RbiError = RbiError;
/**
 * Place generic, non-application specific errors here
 * For ease of maintenance, keep all errors alphabetical and self-documenting
 */
class BrandNotSupportedError extends RbiError {
    constructor(brand) {
        super(`This functionality is not supported for Brand '${brand}'.`);
    }
}
exports.BrandNotSupportedError = BrandNotSupportedError;
class CastError extends RbiError {
    constructor(errors, data) {
        super(`Cast failed: ${errors.join(', ')}`);
        this.errors = errors;
        this.data = data;
        this.statusCode = http_status_codes_1.default.BAD_REQUEST;
    }
}
exports.CastError = CastError;
class EnumMemberNotFoundError extends RbiError {
    constructor(receivedValue, expectedValues) {
        super(`Unknown enum value received: got ${receivedValue}, expected one of ${expectedValues.join(' | ')}`);
        this.statusCode = http_status_codes_1.default.NOT_FOUND;
    }
}
exports.EnumMemberNotFoundError = EnumMemberNotFoundError;
class MissingRequiredParametersError extends RbiError {
    constructor(...parameters) {
        super(`Missing required parameters.  ${parameters.join()}`.trimRight());
        this.statusCode = http_status_codes_1.default.BAD_REQUEST;
    }
}
exports.MissingRequiredParametersError = MissingRequiredParametersError;
class PosVendorMismatchError extends RbiError {
    constructor(value, ...expectations) {
        super(`The POS Vendor ${value} does not match expectations ${expectations.join()}.`);
        this.statusCode = http_status_codes_1.default.BAD_REQUEST;
    }
}
exports.PosVendorMismatchError = PosVendorMismatchError;
class UnknownBrandError extends RbiError {
    constructor(brand) {
        super(`Brand '${brand}' is not known or not configured.`);
    }
}
exports.UnknownBrandError = UnknownBrandError;
class UnknownRbiMessageQueueError extends RbiError {
    constructor(...parameters) {
        super(`No RBI message queue could be found using identifiers: ${parameters.join()}`);
    }
}
exports.UnknownRbiMessageQueueError = UnknownRbiMessageQueueError;
class UnknownRbiMethodError extends RbiError {
    constructor(...parameters) {
        super(`No RBI method could be found using identifiers: ${parameters.join()}`);
    }
}
exports.UnknownRbiMethodError = UnknownRbiMethodError;
class UnknownStageError extends RbiError {
    constructor(stage) {
        super(`Stage '${stage}' is not known or not configured.`);
    }
}
exports.UnknownStageError = UnknownStageError;
class UnknownRegionError extends RbiError {
    constructor(region) {
        super(`Region '${region}' is not known or not configured.`);
    }
}
exports.UnknownRegionError = UnknownRegionError;
//# sourceMappingURL=index.js.map